webpackJsonp([9],{

/***/ "4ml/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LlgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c92988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("LlgU");
function injectStyle (ssrContext) {
  __webpack_require__("VOnF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c92988_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_util_js__ = __webpack_require__("yt7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_less__ = __webpack_require__("nrAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_i18n__ = __webpack_require__("TXmL");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_less___default.a);


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$getUrl = __WEBPACK_IMPORTED_MODULE_4__util_util_js__["a" /* default */].getUrlVal;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

var urlParam = function urlParam(name) {
    var href = window.location.href;
    var hrefDecoded = decodeURIComponent(href);
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(hrefDecoded);
    return results == null ? null : results[1];
};

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.request.use(function (config) {
    var token = urlParam('accessToken');
    var locale = urlParam('locale');
    if (token) {
        // 判断是否存在token，如果存在的话，则每个http header都加上token
        config.headers['accessToken'] = token;
        config.headers['locale'] = locale;
        localStorage.setItem("accessToken", token);
        localStorage.setItem("locale", locale);
    }
    return config;
}, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

var lang = urlParam('locale');

if (lang == 'ar') {
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = '../static/arstyle.css'; //css链接
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
}

var i18n = new __WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]({
    locale: lang, // 语言标识,
    messages: {
        'in': __webpack_require__("Q6fU"), // 英文语言包
        'en': __webpack_require__("OzXt"), // 英文语言包
        'ar': __webpack_require__("iQdE") // 英文语言包
    }
});

//window.http = 'https://api-test.funbit.me/funbit/v2/'; //测试地址
window.http = 'https://api.funbit.me/funbit/v2/'; //线上地址

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    i18n: i18n,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "OzXt":
/***/ (function(module, exports) {

module.exports = {"skill_level_title":"Must be your current season’s level","skill_screenshot_title":"Upload a screenshot that can best show your gaming level","skill_info_text_title":"Describe your skill info and what’s special you can offer","skill_info_text_guideline":"Tell people something special about your service:<br/>Ex.<br/>I can easily carry you for a win!<br/>If you need someone to have your back andget your sweet kills, I’ m your girl.” <br/> “I’ m a sweet girl with a sweet voice!” <br/> “I’ m up for playing any mode,as long as we have fun: 3","skill_info_audio_title":"Use your voice to describe your skill info and something special about your service.","skill_info_audio_guideline":"1.3 - 20 seconds <br/>2. Use a cute voice <br/>3. Say hello first then tell people something special about your service.","skill_tag_title":"Choose 2 tags that best describe your specialty","skill_tag_guideline":"Choosing tags that are suitable for your service can get more people to order from you","profile_nickname_title":"Make yourself a cute nickname","profile_nickname_guideline":"Having a cute nickname can get more people to click on your profile","profile_bio_text_title":"Introduce yourself: hobbies, favourite games, personality, and your available times, etc.","profile_bio_text_guideline":"1.Write something special and personal about yourself<br/>2. Always good to add some emoji 😋😘💋<br/>3.Invite customers to play with you: “Chat with me, let’s have fun together😋”","profile_bio_audio_title":"Use a cute voice to introduce yourself: hobbies, favourite games, personality and your available time, etc.","profile_bio_audio_guideline":"1. 3 - 20 seconds<br/>2. Use a cute voice<br/>3. Say hello first then tell people something special about yourself","profile_picture_title":"Use instagramable pictures as your profile picture: must show your face, bright background, not a group picture","profile_picture_guideline":"1. Having a clear face and bright background<br/>2. Well dressed<br/>3. Use photoshops to make it prettier if needed","profile_mobile_number_title":"Must provide your phone number","enter_text":"Enter here","exit_popup_title":"If you leave now, your change won’t be saved","skill_verification_label":"Skill Verification","game_level_label":"Game Level","upload_screenshot_label":"Upload Screenshot","example":"Examples","apply_skill_banner":"Earn money by playing you favorite game and making friends","skill_info_label":"Skill Info","audio_intro_label":"Audio Intro","position_label":"Position","under_review_title":"Under Review","close_button":"Close","next_button":"Next","under_review_status":"Your application is under review now. Due to the high volumn of the application, we expected to respond to you in 14 days.","profile_pic_label":"Profile Picture","gender_label":"Gender","gender_male":"Male","gender_female":"Female","position_hint":"Select your good at gaming positions","max_position_toast":"You can only select up to 3 positions","max_tag_hint":"You can only select up to 2 tags","tap_to_record_label":"Tap to record","tap_to_stop_recording_label":"Tap to stop recording","tap_to_listen_label":"Tap to listen","re_record_label":"Re-record","recrod_three_secs_toast":"Please record at least 3 seconds","choose_service_title":"Choose a service","guideline_label":"Guideline","cancel_button":"Cancel","ok_label":"OK","tags_label":"Tags","confirm_button_text":"Confirm","tap_to_stop_label":"Tap to stop","loading_label":"Loading","nickname_label":"Nickname","bio_label":"Bio","edit_profile_exit_popup_title":"If you leave now, your change won’t be saved","h5_invite_to_game_room_text":"%1%@ invited you to join the game voice room.","h5_join_now_button":"Join Now","h5_download_button":"Download","h5_lita_slogan":"Meet new gamer friends","manage_skills_title":"Manage Skills","reviewing_label":"Reviewing","view_button":"View","add_skill":"Add Skill","skill_desccription":"Skill Description","save_change":"Save Changes","update_profile":"Update Profile","submit_confirmation_popup_title":"New Changes Will be Reviewed","submit_confirmation_popup_text":"If you submit the change request, your skill will be reviewed and takes 1-2 business day to respond to you.<br/><br/>During the review, you can still take orders but you can't submit another change on this skill until the review complete.","under_review_banner_text":"Your application is under review now and no change are allowed at this time. We expected to complete your review in three business days.","new_user_guide_title":"Lita New User Guide","lita_info":"Lita is grouped by beautiful joki and pro players.<br/><br/>We offer gaming companionship service to give you the best gaming service.<br/><br/>Our services includes:<br/>1. Game companionship with voice chatting.<br/>2. Team up with pro: win game so easy and rank up so fast!<br/>3. Game Coaching and help you to improve gaming skills","how_to_title":"How to use Lita","how_to_subtitle_one":"1. Find your ideal player","how_to_subtitle_two":"2. Start converstaion and know the player better","how_to_subtitle_three":"3. Place an order with Lita Coin","how_to_subtitle_four":"4. Add friends in the game and have fun😊","service_guarantee_title":"Service Guarantee","service_guarantee_subtitle_one":"1. Money won't be transferred to the player until you confirm the service is completed.","service_guarantee_subtitle_two":"2. All players from Lita are strictly selected and trianed.","service_guarantee_subtitle_three":"3. If the player gave you a bad experience, we have customer support to help you.","submit_button_text":"Submit","new_label":"New"}

/***/ }),

/***/ "Q6fU":
/***/ (function(module, exports) {

module.exports = {"skill_level_title":"Harus rank/level season saat ini","skill_screenshot_title":"Upload Screenshot level atau rank tertinggimu","skill_info_text_title":"Jelaskan info skill kamu dan apa kelebihan yang bisa kamu berikan","skill_info_text_guideline":"Katakan kepada mereka apa yang special dari jasa kamu. Contoh :<br/>\" Saya dapat dengan mudahnya bantu kamu untuk menang \"<br/>\" Jika kamu butuh seseorang untuk support dan bantu kamu dapat banyak kill, saya orangnya \"<br/>\" Saya cewek cute dengan suara manis \"<br/>\" Saya siap main di mode apapun, yang penting kita bisa main fun \"","skill_info_audio_title":"Gunakan suaramu untuk menjelaskan info skill dan sesuatu yang menarik dari jasamu","skill_info_audio_guideline":"1. 3 - 20 detik<br/>2. Pake suara manis<br/>3. Katakan Hai dulu dan ceritakan kelebihan dari jasa servismu.","skill_tag_title":"Pilih 2 Tag Pin yang mencerminkan kelebihanmu","skill_tag_guideline":"Pilih Tag yang cocok dengan jasa kamu akan memudahkan banyak user bermain denganmu","profile_nickname_title":"Bikinlah nick yang bagus/cute","profile_nickname_guideline":"Nick name yang cute/bagus bisa membuat banyak user melihat profilmu","profile_bio_text_title":"Jelaskan tentang dirimu : hobi,game favorit, kepribadian, dan waktu luang bermainmu,dll","profile_bio_text_guideline":"1. Tulis sesuatu yang spesial dan menarik dari dirimu.<br/>2. Akan bagus jika menambah beberapa emoji 😘😋💋<br/>3. Ajak user untuk bermain denganmu : \" Chat aku, ayo kita main fun bareng 😋 \"","profile_bio_audio_title":"Gunakan suara yang cute untuk memperkenalkan diri Anda: hobi, permainan favorit, kepribadian dan waktu luang Anda, dll.","profile_bio_audio_guideline":"1. 3 - 20 detik<br/>2. Gunakan suara yang lucu<br/>3. Katakan hai dulu, baru ceritakan sesuatu yang spesial tentang diri Anda","profile_picture_title":"Gunakan gambar yang instagramable sebagai gambar profil Anda: harus menunjukkan wajah Anda, background cerah, bukan foto grup","profile_picture_guideline":"1. Memiliki wajah yang bening dan background yang cerah<br/>2. Berpakaian rapi<br/>3. Gunakan photoshop agar lebih cantik jika diperlukan","profile_mobile_number_title":"Harus memberikan nomor telepon Anda","enter_text":"Enter disini","exit_popup_title":"Jika kamu keluar sekarang, perubahan tidak akan disimpan","skill_verification_label":"Verifikasi Keterampilan","game_level_label":"Level Game","upload_screenshot_label":"Unggah Screenshot","example":"Contoh","apply_skill_banner":"Hasilkan uang dengan memainkan game favorit Anda dan berteman","skill_info_label":"Info Keterampilan","audio_intro_label":"Pengantar Audio","position_label":"Posisi","under_review_title":"Sedang Ditinjau","close_button":"Menutup","next_button":"Lanjut","under_review_status":"Permohonan Anda sedang ditinjau sekarang. Mengingat banyaknya pendaftar, kami berharap dapat menanggapi Anda dalam 14 hari.","profile_pic_label":"Gambar profil","gender_label":"Jenis Kelamin","gender_male":"Laki-laki","gender_female":"Perempuan","position_hint":"Pilih keahlian Anda dalam posisi permainan","max_position_toast":"Anda hanya dapat memilih maksimal 3 posisi","max_tag_hint":"Anda hanya dapat memilih maksimal 2 tag","tap_to_record_label":"Tap untuk merekam","tap_to_stop_recording_label":"Tap untuk stop rekam","tap_to_listen_label":"Tap untuk mendengar","re_record_label":"Rekam ulang","recrod_three_secs_toast":"Tolong rekam minimal 3detik.","choose_service_title":"Pilih layanan","guideline_label":"Pedoman","cancel_button":"Batal","ok_label":"OK","tags_label":"Tag","confirm_button_text":"Konfirm","tap_to_stop_label":"Ketuk untuk berhenti","loading_label":"Memuat...","nickname_label":"Nickname","bio_label":"Biodata","edit_profile_exit_popup_title":"Jika kamu keluar sekarang, perubahan tidak akan disimpan","h5_invite_to_game_room_text":"%1%@ mengundangmu untuk bergabung di kamar suara game","h5_join_now_button":"Gabung Sekarang","h5_download_button":"Mengunduh","h5_lita_slogan":"Bertemu Teman Gamer Baru","manage_skills_title":"Managemen Layanan","reviewing_label":"Meninjau","view_button":"Lihat","add_skill":"Tambah Layanan","skill_desccription":"Deskripsi Skill","save_change":"Simpan Perubahan","update_profile":"Perbarui Profil","submit_confirmation_popup_title":"Perubahan baru akan ditinjau.","submit_confirmation_popup_text":"Jika Anda mengirimkan permintaan perubahan, keahlian Anda akan ditinjau dan membutuhkan waktu 1-2 hari kerja untuk menanggapi Anda.<br/><br/>Selama peninjauan, Anda masih dapat menerima orderan tetapi Anda tidak dapat mengirimkan perubahan lagi pada keahlian ini hingga ditinjau lengkap.","under_review_banner_text":"Pendaftaran Anda sedang dalam peninjauan dan tidak ada perubahan yang diperbolehkan untuk saat ini. Kami berharap dapat menyelesaikan tinjauan Anda dalam tiga hari kerja.","new_user_guide_title":"Panduan User Baru Lita","lita_info":"Yang muncul dan standby di dalam aplikasi adalah pendamping game cantik dan pemain pro Lita.<br/><br/>Kami menawarkan jasa pendamping game untuk memberi Anda layanan game terbaik.<br/><br/>Layanan kami meliputi:<br/>1. Pendamping Game dengan obrolan suara.<br/>2. Bekerja sama dengan profesional: menangkan game dengan sangat mudah dan naik peringkat dengan cepat!<br/>3. Pelatihan Game dan membantu Anda meningkatkan keterampilan bermain game","how_to_title":"Bagaimana Cara Pake Lita","how_to_subtitle_one":"Cari pemain idamanmu","how_to_subtitle_two":"Ajaklah chat supaya lebih mengenal pemain","how_to_subtitle_three":"Lakukan pemesanan/Order dengan Koin Lita","how_to_subtitle_four":"Saling add ID di game dan bersenang2lah","service_guarantee_title":"Jaminan Layanan","service_guarantee_subtitle_one":"1. Uang tidak akan ditransfer ke pemain sampai Anda mengkonfirmasi layanan selesai.","service_guarantee_subtitle_two":"2. Semua pemain dari Lita diseleksi dan dilatih dengan ketat.","service_guarantee_subtitle_three":"3. Jika pemain memberi Anda pengalaman buruk, kami memiliki Costumer Service untuk membantu Anda.","submit_button_text":"Kirim","new_label":"Baru"}

/***/ }),

/***/ "VOnF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_less__ = __webpack_require__("nrAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant__ = __webpack_require__("Fd2+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_lib_index_css__ = __webpack_require__("4ml/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vant_lib_index_css__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_less___default.a);

var index = function index(r) {
    return __webpack_require__.e/* require.ensure */(7).then((function () {
        return r(__webpack_require__("dAjm"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var skillone = function skillone(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__("d+S3"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var skilltwo = function skilltwo(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__("P4t9"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var skillthree = function skillthree(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__("3IZ+"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var auditing = function auditing(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__("dqEk"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var test = function test(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__("EXDq"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var testList = function testList(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__("h3xF"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var managehome = function managehome(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("otRT"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var manageSkill = function manageSkill(r) {
    return __webpack_require__.e/* require.ensure */(5).then((function () {
        return r(__webpack_require__("te2e"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var manageSkillOne = function manageSkillOne(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__("b5Mh"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var manageSkillTwo = function manageSkillTwo(r) {
    return __webpack_require__.e/* require.ensure */(4).then((function () {
        return r(__webpack_require__("iDTz"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Manskillone = function Manskillone(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__("sAQd"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Manskilltwo = function Manskilltwo(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__("Jfop"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Manauditing = function Manauditing(r) {
    return __webpack_require__.e/* require.ensure */(6).then((function () {
        return r(__webpack_require__("D/0U"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Mantest = function Mantest(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__("B/kI"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MantestList = function MantestList(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__("nXcn"));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vant__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'index',
        component: index
    }, {
        path: '/skillone',
        name: 'skillone',
        component: skillone
    }, {
        path: '/skilltwo',
        name: 'skilltwo',
        component: skilltwo
    }, {
        path: '/skillthree',
        name: 'skillthree',
        component: skillthree
    }, {
        path: '/auditing',
        name: 'auditing',
        component: auditing
    }, {
        path: '/test',
        name: 'test',
        component: test
    }, {
        path: '/testList',
        name: 'testList',
        component: testList
    }, {
        path: '/managehome',
        name: 'managehome',
        component: managehome
    }, {
        path: '/manageSkill',
        name: 'manageSkill',
        component: manageSkill
    }, {
        path: '/manageSkillOne',
        name: 'manageSkillOne',
        component: manageSkillOne
    }, {
        path: '/manageSkillTwo',
        name: 'manageSkillTwo',
        component: manageSkillTwo
    }, {
        path: '/Manskillone',
        name: 'Manskillone',
        component: Manskillone
    }, {
        path: '/Manskilltwo',
        name: 'Manskilltwo',
        component: Manskilltwo
    }, {
        path: '/Manauditing',
        name: 'Manauditing',
        component: Manauditing
    }, {
        path: '/Mantest',
        name: 'Mantest',
        component: Mantest
    }, {
        path: '/MantestList',
        name: 'MantestList',
        component: MantestList
    }]
}));

/***/ }),

/***/ "iQdE":
/***/ (function(module, exports) {

module.exports = {"skill_level_title":"يجب أن تكون رتبة هذا الموسم","skill_screenshot_title":"قم بتحميل لقطة شاشة تظهر رتبتك الحالية","skill_info_text_title":"قدم وصف لمهارتك وما هو الشيء المميز الذي يمكنك تقديمه","skill_info_text_guideline":"مثال:<br/> \"يمكنني بسهولة أن أحملك للفوز!\"<br/> \"إذا كنت بحاجة إلى شخص ما ليحمي ظهرك ويجعلك تحصل على الكيلاّت الرائعة، فأنا هنا من أجلك.\"<br/>\"أنا فتاة حلوة بصوت لطيف!\"<br/>\"أنا مستعد للعب أي دور في اللعبة، طالما أننا نستمتع بوقتنا.\"","skill_info_audio_title":"استخدم صوتك لتقديم وصف لمهارتك وعن شيء مميز يمكنك تقديمه في الخدمة","skill_info_audio_guideline":"3 - 20 ثانية<br/>استخدم صوت لطيف<br/> قل مرحبًا أولاً ثم أخبر المستخدمين بشيء مميز عن خدمتك","skill_tag_title":"أختر وسمين يعبرون عنك","skill_tag_guideline":"استخدام الوسوم المناسبة لخدمتك يساعد على جذب المزيد من الأشخاص لإرسال الطلبات لك","profile_nickname_title":"أختر لقب لطيف لنفسك","profile_nickname_guideline":"اختيار لقب لطيف قد يجذب المزيد من المستخدمين للضغط على صفحتك الشخصية","profile_bio_text_title":"قدم نفسك: تحدث عن هواياتك، العابك المفضلة، شخصيتك، الأوقات المتاحة، إلخ.","profile_bio_text_guideline":"اكتب شيئًا مميزًا عن نفسك<br/>يمكنك اضافة بعض الرموز التعبيرية 😋😘💋<br/>قم بدعوة العملاء للّعب معك: \"لندردش سويا ونقضي وقتا ممتعا معًا\"","profile_bio_audio_title":"استخدم صوتا لطيفا لتقديم نفسك: تحدث عن هواياتك، العابك المفضلة، شخصيتك، الأوقات المتاحة، إلخ.","profile_bio_audio_guideline":"3 - 20 ثانية<br/>استخدم صوت لطيف<br/> قل مرحبًا أولاً ثم أخبر المستخدمين بشيء مميز عن خدمتك","profile_picture_title":"استخدم صورة جيدة بشرط ألا تكون صورة جماعية وأن تظهر الوجه بوضوح","profile_picture_guideline":"يجب ان تكون الصورة واضحة والوجه ظاهرا<br/>أن يكون اللبس لائقا<br/>يمكن استخدام الفوتوشوب لتحسين الصورة ان لزم الأمر","profile_mobile_number_title":"يجب كتابة رقم هاتفك","enter_text":"أدخل هنا","exit_popup_title":"إذا غادرت الآن ، فلن يتم حفظ التغيير !","skill_verification_label":"التحقق من المهارة","game_level_label":"مستوى اللعبة","upload_screenshot_label":"تحميل لقطة","example":"مثال","apply_skill_banner":"اكسب المال من خلال لعب لعبتك المفضلة وتكوين صداقات","skill_info_label":"معلومات المهارة","audio_intro_label":"مقدمة الصوت","position_label":"موضع","under_review_title":"قيد المراجعة","close_button":"قريب","next_button":"التالى","under_review_status":"طلبك قيد المراجعة الآن. نظرًا لارتفاع كمية الدفع ، نتوقع الرد عليك في غضون 14 يومًا.","profile_pic_label":"الصوره الشخصيه","gender_label":"النوع","gender_male":"ذكر","gender_female":"أنثى","position_hint":"حدد جيدك في مواقع اللعب","max_position_toast":"يمكنك اختيار ما يصل إلى 3 وظائف فقط","max_tag_hint":"يمكنك تحديد ما يصل إلى علامتين فقط","tap_to_record_label":"اضغط للتسجيل","tap_to_stop_recording_label":"انقر لإيقاف التسجيل","tap_to_listen_label":"انقر للاستماع","re_record_label":"إعادة التسجيل","recrod_three_secs_toast":"الرجاء تسجيل 3 ثوان على الأقل","choose_service_title":"اختر خدمة","guideline_label":"التوجيه","cancel_button":"إلغاء","ok_label":"حسنا","tags_label":"العلامات","confirm_button_text":"تأكيد","tap_to_stop_label":"انقر للتوقف","loading_label":"جار التحميل...","nickname_label":"اللقب","bio_label":"نبذة عن نفسك","edit_profile_exit_popup_title":"إذا غادرت الآن ، فلن يتم حفظ التغيير !","h5_invite_to_game_room_text":"دعاك %1%@ للانضمام إلى لعبة الغرفة الصوتية .","h5_join_now_button":"إنضم الآن","h5_download_button":"حمل","h5_lita_slogan":"تعرف على أصدقاء جدد","manage_skills_title":"إدارة المهارات","reviewing_label":"المراجعة","view_button":"انظر","add_skill":"إضافة المهارة","skill_desccription":"وصف المهارة","save_change":"حفظ التغييرات","update_profile":"تحديت الصفحة الشخصية","submit_confirmation_popup_title":"سيتم مراجعة التغييرات الجديدة","submit_confirmation_popup_text":"إذا قمت بتقديم طلب التغيير ، فستتم مراجعة مهارتك وستستغرق عملية الرد عليك من يوم إلى يومين. </br/><br> أثناء المراجعة ، لا يزال بإمكانك تلقي الطلبات ولكن لا يمكنك إرسال تغيير آخر على هذه المهارة حتى المراجعة اكتمال.","under_review_banner_text":"طلبك قيد المراجعة الآن ولا يسمح بأي تغيير في الوقت الحالي. توقعنا إكمال مراجعتك في غضون ثلاثة أيام عمل.","new_user_guide_title":"دليل مستخدم Lita الجديد","lita_info":"تم تجميع Lita بواسطة لاعبين محترفين ومحترفين.</br/><br> نحن نقدم خدمة مصاحبة الألعاب لنمنحك أفضل خدمة ألعاب. </br/><br> تشمل خدماتنا:</br/><br>- رفقة اللعبة مع الدردشة الصوتية. </br/><br>- تعاون مع المحترفين: اربح لعبة سهلة جدًا واحصل على ترتيب سريع جدًا! </br/><br>- لعبة التدريب وتساعدك على تحسين مهارات اللعب","how_to_title":"كيف تستعمل تطبيق ليتا","how_to_subtitle_one":"1. ابحث عن لاعبك المثالي","how_to_subtitle_two":"2. ابدأ المحادثة وتعرف على اللاعب بشكل أفضل","how_to_subtitle_three":"3. ضع طلبية باستخدام عملة ليتا","how_to_subtitle_four":"4. أضف أصدقاء في اللعبة واستمتع","service_guarantee_title":"خدمة مضمونة","service_guarantee_subtitle_one":"1. لن يتم تحويل الأموال إلى اللاعب حتى تؤكد اكتمال الخدمة.","service_guarantee_subtitle_two":"2. يتم اختيار وتدريب جميع اللاعبين من Lita بدقة.","service_guarantee_subtitle_three":"3. إذا أعطاك اللاعب تجربة سيئة ، فلدينا دعم العملاء لمساعدتك.","submit_button_text":"ارسال","new_label":"جديد"}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	methods: {}
});

/***/ }),

/***/ "yt7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getUrlVal: function getUrlVal() {
        var url = window.location.href;
        var hrefDecoded = decodeURIComponent(url);
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(hrefDecoded);
        return results == null ? null : results[1];
    }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1445985cfd84a912909a.js